/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./shoppingChange.vue?vue&type=template&id=b7e9c91a&scoped=true&"
import script from "./shoppingChange.vue?vue&type=script&lang=js&"
export * from "./shoppingChange.vue?vue&type=script&lang=js&"
import style0 from "./shoppingChange.vue?vue&type=style&index=0&id=b7e9c91a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7e9c91a",
  null
  
)

export default component.exports